import * as React from 'react';
import type { AppBootstrapOptions } from './types/AppBootstrapOptions';
import { bootstrap } from 'owa-bootstrap/lib/bootstrap';
import { registerBootstrapOptions } from './optionsRegistry';
import AppModule from './components/AppModule';
import { initializeModule } from 'owa-app-module-store';
import { firstApp } from 'owa-config/lib/bootstrapOptions';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as trace from 'owa-trace';
import { getOrigin } from 'owa-url/lib/getOrigin';
import { isTokenFetchFromMsalEnabled } from 'owa-msaljs';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { updateServiceConfig } from 'owa-service/lib/config';
import { getServiceWorkerConfig } from './getServiceWorkerConfig';
import { buildAuthorizationHeader } from 'owa-tokenprovider-utils';

export async function appBootstrap(options: AppBootstrapOptions) {
    if (isHostAppFeatureEnabled('incorrectNativeEntryPoint') && firstApp != 'Native') {
        trace.errorThatWillCauseAlert('IncorrectNativeEntryPoint');
    }

    const mod = options.appModuleProps!.module;
    initializeModule(mod);
    const serviceWorkerConfig = getServiceWorkerConfig(
        mod,
        isHostAppFeatureEnabled('opxServiceWorker')
    );
    if (serviceWorkerConfig) {
        options.swConfig = serviceWorkerConfig;
    }

    await registerBootstrapOptions(options);

    const suiteWrapper = options.strategies?.suiteWrapper;
    const components = suiteWrapper ? await suiteWrapper.import() : undefined;
    let wrapSuiteHeader: ((suiteHeader: React.ReactNode) => React.ReactNode) | undefined;
    if (components) {
        options.windowIcons = components.windowIcons;
        wrapSuiteHeader = suiteHeader => <components.suiteHeader suiteHeader={suiteHeader} />;
    }

    options.renderMainComponent = () => <AppModule wrapSuiteHeader={wrapSuiteHeader} />;

    return bootstrap(options).then(() => {
        const resource = getOrigin() + '/';
        if (
            isFeatureEnabled('auth-msaljs-fetchResourceToken-owa') &&
            isTokenFetchFromMsalEnabled(resource)
        ) {
            const asyncGetAuthToken = async () => {
                let [token, tokenPromise] = getAccessTokenforResourceAsLazy(resource);
                if (!token) {
                    token = (await tokenPromise) as string;
                }

                return token ? buildAuthorizationHeader(token as string) : undefined;
            };

            updateServiceConfig({
                getAuthToken: asyncGetAuthToken,
            });
        }
    });
}
